
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


// As well, ShopX uses a build time package.json for brand/env file updates:
// "penv": "npx penv"
// sxeang\environments.json

import { EnvironmentConfig } from "../environment.interface";

export const environment: EnvironmentConfig  = {
  configurationName: 'mn-uat',
  production: false,
  // *** TO ORGANIZE ENVIRONMENT FILES BETTER, SWITCH TO THE STRUCTURED DATA AS BELOW!!! ***
  configs: {
    aspName: 'Blue Cross Blue Shield of Minnesota',
    npnEnabled: false,
    siteTimeZone: 'MINNESOTA',
    brandBandAidOverrides: { optOutBetaRedirect: true },
  },
  infrastructure: {
    deploymentDomain: 'bluecrossmnonline.com',
    datapower: {
      baseUrl: 'https://medicaretenv3.bluecrossmnonline.com'
    },
    axway: {
      webServiceUrl: 'https://apiwebqa.hmhs.com',
      jwtBaseURL: 'https://oauthqa.hmhs.com',
      prePassKey: '836d554d-0f86-4972-b838-93729c4dd692'
    },
    googleCloud: {
      baseUrl: 'https://us-central1-shopx-components-uat.cloudfunctions.net',
      angularHostUrl: 'https://shopxcdntenv3.hmhs.com/mn/browser/en/'
    },
    oauth: {
      baseUrl: 'https://logintest.bluecrossmnonline.com',
      client_id: '447a347-a4d5-7704-44e75454d4e335a49706b746464513d3d',
      client_secret: '6e6e592b44305548456b4e6e7a786678674d444a36513d3d',
      xOauthIdentityDomainName: 'ProducerPortalMN',
      isSSOLogin: true,
      extraScope: 'engen.health-plan.bcbsmn',
      loginFailureURLs: {
          sso: 'authentication/sso-failure',
          updateEntitlements: 'authentication/update-entitlement-failure'
      }
    },
    oAuthV2: {
      baseUrl: 'https://logintest.bluecrossmnonline.com',
      client_id: 'Mzk0ZjM2NS04NWE2LWU3NjctNDQ2NmU2ZjJiNDg0ODQyMzY1NDcxNTc1ODQ3NjczZDNk',
      client_secret: '',
      xOauthIdentityDomainName: 'producerportal'
    },
    oAMV4: {
      baseUrl: 'https://logintest.bluecrossmnonline.com',
      client_id: '',
      xOauthIdentityDomainName: ''
    },
    connecture: {
      lookupUrlPath: '/APIToolsAlt/v1',
      sessionUrlPath: '/APIPlanCompareAlt/v1/Session'
    }
  },
  external: {
    engen: {
      planAdvisor: {
          domain: 'https://plnadvtenv3.bluecrossmnonline.com'
      },
      eBill: {
        url: 'https://logintest.highmark.com/oauth2/rest/token',
        xOauthIdentityDomainName: 'salesportal',
        client_id: 'NjI3Mzc3Ni00MmI0LTEzNjQtNjU5NTU0YjUwNjYzMzUxNWE0YzU2NTk2YTQ2NDEzZDNk',
        client_secret: '',
        overrideEnv: 'sxesvc-tenv3.apps.ocbrlnxd01.ocp.highmark.com'       
      }
    },
    vendors: {
      agentCubeUrl: '',
      rrdLink: '',
    },
  },
  // Only put data necessary to initiate the application
  initData: {
    brand: {
      ddToken: '14',
      ASPID: 'MN',
      singleBrandASP: true,
      defaultZip: '',

      zipCountyMock: {
        code: 21,
        county: 'default',
        region: 'MN',
        ubk: '9014',
        brand: 'MNBCBS',
        microMarket: 'temp',
        ratingRegion: '',
        state: 'MN',
        fipsCode: '56021',
        ratingArea: 2,
        ffmRatingArea: 'MN002',
        serviceZones: [
          {
            name: 'MN',
            value: 'A'
          }
        ],
        serviceZonesByPlanYear: {}
      }
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
